import { LaunchAdSerializer } from "@models/serializers/launchAdSerializer";
import { httpRequest } from "../../http";

export type LaunchAdListFilters = {
  launch_id?: number;
  organization_id?: number;
  status?: string;
  todo_id?: number;
  expand?: string;
};

export class CommandGetLaunchAds {
  async run(filters: LaunchAdListFilters) {
    const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/launch-ads/`;
    const params = new URLSearchParams();

    if (filters.launch_id != null) params.set("launch_id", String(filters.launch_id));
    if (filters.organization_id != null) params.set("organization_id", String(filters.organization_id));
    if (filters.status) params.set("status", filters.status);
    if (filters.todo_id != null) params.set("todo_id", String(filters.todo_id));
    if (filters.expand) params.set("expand", filters.expand);

    const qs = params.toString();
    const url = qs ? `${base}?${qs}` : base;

    try {
      const response = await httpRequest<any>(url, { method: "GET" });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any) {
    return new LaunchAdSerializer().deserializeList(data);
  }
}
